import { render, staticRenderFns } from "./ProcurationStep5.vue?vue&type=template&id=0e145dd1&scoped=true&"
import script from "./ProcurationStep5.vue?vue&type=script&lang=js&"
export * from "./ProcurationStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e145dd1",
  null
  
)

export default component.exports